import React, { useState } from "react";
import { Image, Smile, Send } from "lucide-react";
import { PostCardProps } from "../interfaces/post.interface";
import { useAuthStore } from "../../../../../auth/auth.store";

const PostCard: React.FC<PostCardProps> = ({
  onOpenModal,
  onSubmit,
}) => {
  const [content, setContent] = useState("");
  const currentUser = useAuthStore((s) => s.currentUser);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const value = content.trim();

    if (!value) return;

    onSubmit(value);
    setContent("");
  };

  // ✅ صورة المستخدم أو placeholder
  const avatarSrc =
    currentUser?.avatarUrl ||
    `https://ui-avatars.com/api/?name=${encodeURIComponent(
      currentUser?.name ?? "User"
    )}&background=ccc&color=000&size=128`;

  return (
    <div className="rounded-lg bg-white p-4 shadow dark:bg-deepSlate">
      <form onSubmit={handleSubmit}>
        {/* Composer */}
        <div className="flex items-center gap-3">
          {/* Profile */}
          <img
            src={avatarSrc}
            alt={currentUser?.name ?? "Profile"}
            className="h-10 w-10 rounded-full object-cover"
          />

          {/* Input */}
          <input
            type="text"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder={`What's on your mind, ${
              currentUser?.name ?? "friend"
            }?`}
            className="flex-1 rounded-full bg-gray-200 px-4 py-2 text-gray-700 outline-none transition focus:ring-2 focus:ring-primary-500 dark:bg-slate-700 dark:text-gray-200"
          />

          {/* Send */}
          {content.trim() && (
            <button
              type="submit"
              className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-600 text-white transition hover:bg-primary-700"
            >
              <Send size={18} />
            </button>
          )}
        </div>
      </form>

      {/* Actions */}
      <div className="mt-4 flex border-t pt-3 dark:border-gray-700">
        {/* Image */}
        <button
          type="button"
          onClick={() => onOpenModal("image")}
          className="flex flex-1 items-center justify-center gap-2 rounded-lg py-2 text-gray-600 transition hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-slate-700"
        >
          <Image size={22} className="text-green-500" />
          <span className="text-sm font-medium">Photo</span>
        </button>

        {/* Emoji */}
        <button
          type="button"
          onClick={() => onOpenModal("emoji")}
          className="flex flex-1 items-center justify-center gap-2 rounded-lg py-2 text-gray-600 transition hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-slate-700"
        >
          <Smile size={22} className="text-yellow-500" />
          <span className="text-sm font-medium">Feeling / Activity</span>
        </button>
      </div>
    </div>
  );
};

export default PostCard;